import cx from 'classnames'
import React from 'react'

import { HeartOutline } from '@cinch/oxd-components/icons/src'
import SVG from '@cinch/oxd-components/svg/src'
import tokens from '@cinch/oxd-utils/tokens/src'

import * as styles from './icon-list.module.css'

interface IconListProps {
  bulletText: string[]
  bulletIcon?: any
  iconSize?: number
  hasGradient?: boolean
  gradientId?: string
  className?: string
  itemClassName?: string
  doesWrap?: boolean
}

const IconList: React.FC<IconListProps> = ({
  bulletText,
  bulletIcon = HeartOutline,
  iconSize,
  hasGradient = false,
  gradientId = 'alpha',
  className = '',
  itemClassName = '',
  doesWrap = false,
}) => {
  const iconProps: any = {
    className: styles.icon,
    size: iconSize || tokens.customProperties.spacing.l,
    children: bulletIcon,
  }
  if (hasGradient) {
    iconProps.hasGradient = true
    iconProps.gradientId = gradientId
  }

  return (
    <ul className={cx(styles.list, className, { [styles.listWrap]: doesWrap })}>
      {bulletText.map((bullet, index) => (
        <li key={index} className={cx(styles.listItem, itemClassName)}>
          <SVG {...iconProps} />
          <span className={styles.listText}>{bullet}</span>
        </li>
      ))}
    </ul>
  )
}

export default IconList
